import React from 'react';

const PolaroidVisual = ({ revealMeta = {} }) => {
  const polaroidState = revealMeta.polaroidState || {};
  const hasPhoto = Boolean(polaroidState.hasPhoto && polaroidState.photoUrl);

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-polaroid${hasPhoto ? ' has-photo' : ' is-empty'}`}
      aria-hidden="true"
    >
      <span className="shutter-flash" />
      <span className="camera">
        <i className="lens" />
        <i className="flash" />
        <i className="stripe-a" />
        <i className="stripe-b" />
      </span>
      <span className="print">
        {hasPhoto ? (
          <img src={polaroidState.photoUrl} alt="" loading="lazy" />
        ) : (
          <span className="empty-photo" />
        )}
        <b className="caption-line">{polaroidState.caption || 'Add a snapshot'}</b>
      </span>
    </span>
  );
};

export default PolaroidVisual;
